import { DeploymentReportTable } from "@/components/media-transmitters/deployment-report-table";

export function DeploymentReportPage() {
	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			<DeploymentReportTable />
		</div>
	);
}
